import { Component } from "@angular/core";
import { RouterLink, RouterOutlet } from "@angular/router";
import { ApplicationsTableComponent } from "../common/components/applications-table/applications-table.component";
import { WelcomeComponent } from "./welcome/welcome.component";

@Component({
  selector: "app-student-dashboard",
  standalone: true,
  imports: [
    WelcomeComponent,
    RouterOutlet,
    RouterLink,
    ApplicationsTableComponent,
  ],
  templateUrl: "./student-dashboard.component.html",
  styleUrl: "./student-dashboard.component.scss",
})
export class StudentDashboardComponent {}
